// extracted by mini-css-extract-plugin
module.exports = {"flex":"NameInput_flex__1OaQC","input":"NameInput_input__luiEz"};